import { z } from 'zod';
import { RefreshTokenError } from 'libs/end-to-end/src/types/errors/refresh-token-error';
import { LoginError } from 'libs/end-to-end/src/types/errors/login-error';
import { InvalidTokenError } from 'libs/end-to-end/src/types/errors/invalid-token-error';
import { EmailAlreadyTakenError } from 'libs/end-to-end/src/types/errors/email-already-taken-error';
import { PasswordComplexityError } from 'libs/end-to-end/src/types/errors/password-complexity-error';
import { HttpRequestError } from 'libs/end-to-end/src/types/errors/http-request-error';
import { UserNotFoundError } from 'libs/end-to-end/src/types/errors/user-not-found-error';
import { UserEmailNotFoundError } from 'libs/end-to-end/src/types/errors/user-email-not-found-error';
import { UnknownError } from 'libs/end-to-end/src/types/errors/unknown-error';

export const AuthError = z.union([
  LoginError,
  RefreshTokenError,
  InvalidTokenError,
  EmailAlreadyTakenError,
  PasswordComplexityError,
  HttpRequestError,
  UserNotFoundError,
  UserEmailNotFoundError,
  UnknownError,
]);

export type AuthError = z.infer<typeof AuthError>;
